import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrganisationDto } from '@careapp-group/ng-sdk';

@Component({
  selector: 'ca-organisation-list-select-compact',
  templateUrl: './organisation-list-select-compact.component.html',
  styleUrls: ['./organisation-list-select-compact.component.scss'],
  standalone: false,
})
export class OrganisationListSelectCompactComponent {
  _search = '';
  public tableConfig = [
    {
      key: 'name',
      sortable: false,
      title: 'Organisation',
    },
  ];

  @Input() organisations: { [key: string]: OrganisationDto } = {};
  @Input() selectedIds: string[] = [];
  @Input() disabledIds: string[] = [];
  @Input() single?: boolean = false;
  @Input() readOnly?: boolean = false;

  @Output() selectedIdChange = new EventEmitter<string[]>();

  toggle(organisation?: OrganisationDto) {
    if (organisation == null) {
      return;
    }

    const isSelected = !!(this.selectedIds ?? []).find((id) => id === organisation.id);

    if (this.single && !isSelected) {
      this.selectedIds = [organisation.id!];
    } else {
      this.selectedIds = isSelected
        ? (this.selectedIds ?? []).filter((id) => id !== organisation.id)
        : [...(this.selectedIds ?? []), organisation.id!];
    }

    this.emitIds();
  }

  set search(value: string) {
    this._search = value;
  }
  get search() {
    return this._search;
  }
  get selectedIdFilter() {
    return (item: OrganisationDto, _: any) => item && this.selectedIds.includes(item.id!);
  }

  selectOrgs(orgs: { [key: string]: OrganisationDto }) {
    this.selectedIds = Object.keys(orgs);
    this.emitIds();
  }

  emitIds() {
    if (this.selectedIdChange != null) {
      this.selectedIdChange.emit(this.selectedIds);
    }
  }
}
